import { render, staticRenderFns } from "./sport_event_status_changed.vue?vue&type=template&id=6651d6fb&scoped=true&"
import script from "./sport_event_status_changed.vue?vue&type=script&lang=js&"
export * from "./sport_event_status_changed.vue?vue&type=script&lang=js&"
import style0 from "./sport_event_status_changed.vue?vue&type=style&index=0&id=6651d6fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6651d6fb",
  null
  
)

export default component.exports